const Events = require('PSEvents');
const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        label: cc.Label,
        betLabel: cc.Label,
        winLabel: cc.Label,
        balanceLabel: cc.Label
    },

    setData (data) {
        const convertedTime = this._format(data.duration);
        
        this.label.string = i18n.t('realityCheckContent', { '0': convertedTime });
        this.betLabel.string = i18n.t('bet') + ':' + i18n.formatCurrency(data.sumBetAmount);
        this.winLabel.string = i18n.t('win') + ':' + i18n.formatCurrency(data.sumWinAmount);
        this.balanceLabel.string = i18n.t('balanceChange') + ':' +
            i18n.formatCurrency(data.gamingBalanceChangeAmount);
        this.betLabel.node.parent.getComponent(cc.Layout).updateLayout();
    },

    _format(d) {
        d = Number(d);
        const h = Math.floor(d / 3600);
        const m = Math.floor(d % 3600 / 60);
        const s = Math.floor(d % 3600 % 60);

        var hDisplay = h > 0 ? this._filterDigit(h) + ':' : '';
        var mDisplay = m > 0 ? this._filterDigit(m) + ':' : '00:';
        var sDisplay = s > 0 ? this._filterDigit(s) : '00';
        return hDisplay + mDisplay + sDisplay;
    },

    _filterDigit (d) {
        d = d.toString();
        if (d.length === 1) {
            return '0' + d
        }
        return d;
    }
});
